import React from "react";
import "./About.scss";
import { Box, Flex, Text } from "@chakra-ui/react";

const About = () => {
  return (
    <>
      <div className="about_head">
        <h3 className="head1">ABOUT LEARNERKIA</h3>
        <Flex direction="row" wrap="wrap" className="boxes">
          <Box width={{ base: "100%", md: "50%", lg: "50%" }}>
            <div className="about-cont-inner">
              <Text className="mini-head1">Learnerkia</Text>
              <Text>
                Learnerkia - a learning management system tailored to be
                customized to the needs of Corporate organizations’ learning and
                development needs for:
              </Text>
              <Text className="mini-head">Employees</Text>
              <Text>
                We provide a reliable human resource process from recruitment to
                employee management through database of records and courses for
                training and skills acquisition.
              </Text>
              <Text className="mini-head">Partners</Text>
              <Text>
                The LMS allows for module customisation to include features
                relevant to your organisation.
              </Text>
              <Text className="mini-head">Special Customers</Text>
              <Text>
                The LMS allows for module customisation to include features
                relevant to your organisation.
              </Text>
            </div>
          </Box>
          <Box>
            <img className="mobile" src="/images/mobile.png" alt="mobile" />
          </Box>
        </Flex>
        <div className="ellipse">
          <div className="ellipse1" />
          <div className="ellipse2" />
        </div>
      </div>
      <h3 className="get-started d-none" style={{ color: "#00a2e8" }}>
        Getting started
      </h3>
    </>
  );
};

export default About;
